import React from 'react'
import { Row, Col, Image} from 'react-bootstrap'


const Body = () => {
    return (
      <div id="bodybg">
            <div className='container'>
      <Row>
      <Col sm={6}>
<div className='women'>
<Image src='/images/experience-des.png' alt='women-smiling' className='img-women'/>

</div>

</Col>
<Col sm={6}>
<div className='thirddiv'>
 <h4>Tolu &#38; Joy's Experience</h4>
      <p id='title'>CUSTOMER</p>
      <p id='text1'>
      I had the best experience shopping with vasiti. <br/>            
      Usability of the website was great, very good <br/> 
      customer service, an all round great <br/>
      experience. I would definately be coming back! <br/>
       I had the best experience shopping with vasiti.<br/>
       Usability of the website was great, very good <br/>
        customer service, an all round great <br/>
         experience. 
      I would definately be coming back!
      </p>
      <p id='share'>SHARE YOUR OWN STORY!</p>
      </div>
  </Col>

</Row>


</div>
</div>
    )
}

export default Body
